import type { Optional } from '@festina-life/core'
import { IconButton } from '@festina-life/ui/actions'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { PropsWithChildren, ReactNode } from 'react'

type Props = PropsWithChildren<{
  onClose: () => void
  header: ReactNode
  status?: Optional<ReactNode>
}>

export const DetailsPanel = ({ children, header, status, onClose }: Props) => (
  <div className="flex flex-col size-full overflow-hidden">
    <div
      className={cx(
        'flex items-center justify-between p-2',
        paperStyles({ isFaded: true, borders: ['bottom'] }),
      )}
    >
      <div className="flex items-center gap-x-4">{header}</div>
      <div className="flex gap-x-2 items-center">
        {status}
        <IconButton iconName="XMark" onClick={onClose} />
      </div>
    </div>
    <div className="h-full overflow-hidden">{children}</div>
  </div>
)
